// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { chatManagerMiddleware } from "./middleware/chatManagerMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "ADD_MESSAGE",
          "RECEIVE_MESSAGE",
          "UPDATE_MESSAGE",
          "LOAD_MESSAGES_SUCCESS",
          "messages/initializeFromDB/pending",
          "messages/initializeFromDB/fulfilled",
          "streaming/socketUiErrorShow",
          "streaming/socketConnectionError",
          "streaming/socketAudioRecordingError",
          "streaming/socketLanguageError",
          "streaming/socketVadError",
          "textContent/setTextLanguageDetectionError",
          "textContent/setContentGenerationError",
          "textContent/setNerDetectionError",
        ],
        ignoredActionPaths: [
          "payload",
          "message",
          "json",
          "textContent.contentGenerationError",
          "textContent.textLanguageDetectionError",
          "textContent.nerDetectionError",
          "streaming.audioError",
          "streaming.error",
          "streaming.languageError",
          "streaming.vad.error",
        ],
        ignoredPaths: ["messages.chats"],
      },
    }).concat(chatManagerMiddleware),
  devTools: import.meta.env.MODE !== "production",
});

export default store;
